module.exports = __webpack_public_path__ + "static/media/username-icon.b1577793.svg";